import { watch } from 'vue';
import { useRoute } from 'vue-router';
import { useSiteConfigStore } from '@/stores/siteConfig';

const CANONICAL_LINK_ID = 'spa-canonical-link';

/**
 * When `google_index` is enabled (production SEO), set `<link rel="canonical">` to the
 * current path (no hash or query — locale and slug live in the path).
 */
export function useCanonicalLink(): void {
  const route = useRoute();
  const siteConfig = useSiteConfigStore();

  watch(
    () => [siteConfig.googleIndex, route.path] as const,
    ([indexed, path]) => {
      const existing = document.querySelector<HTMLLinkElement>(
        `link#${CANONICAL_LINK_ID}`
      );
      if (!indexed) {
        existing?.remove();
        return;
      }
      const origin =
        typeof window !== 'undefined' ? window.location.origin : '';
      const normalizedPath = path && path.startsWith('/') ? path : `/${path || ''}`;
      const href = `${origin}${normalizedPath}`;
      let link = existing;
      if (!link) {
        link = document.createElement('link');
        link.id = CANONICAL_LINK_ID;
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = href;
    },
    { immediate: true }
  );
}
